if (!customElements.get('seo-text-block')) {
  customElements.define(
    'seo-text-block',
    class SeoTextBlock extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.seo-text-block__content');
        this.buttonWrapper = this.querySelector('.seo-text-block__button-wrapper');
        this.button = this.querySelector('.seo-text-block__toggle');
        this.label = this.querySelector('.seo-text-block__toggle-label');

        if (!this.content || !this.button) return;

        this.readMoreText = this.dataset.readMore || 'Read More';
        this.seeLessText = this.dataset.seeLess || 'See Less';
        this.expanded = false;

        this.splitContent();

        if (this.hiddenWrapper) {
          this.button.addEventListener('click', this.toggle.bind(this));
        } else if (this.buttonWrapper) {
          this.buttonWrapper.style.display = 'none';
        }
      }

      splitContent() {
        const children = Array.from(this.content.children);
        if (children.length === 0) return;

        const firstH2Index = children.findIndex((el) => el.tagName === 'H2');
        let keepUntil;

        if (firstH2Index === -1) {
          let paragraphs = 0;
          keepUntil = -1;
          for (let i = 0; i < children.length; i++) {
            keepUntil = i;
            if (children[i].tagName === 'P') {
              paragraphs += 1;
              if (paragraphs >= 2) break;
            }
          }
        } else {
          keepUntil = firstH2Index;
          let paragraphs = 0;
          for (let i = firstH2Index + 1; i < children.length; i++) {
            keepUntil = i;
            if (children[i].tagName === 'P') {
              paragraphs += 1;
              if (paragraphs >= 2) break;
            }
          }
        }

        const hiddenChildren = children.slice(keepUntil + 1);
        if (hiddenChildren.length === 0) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'seo-text-block__hidden';
        hiddenChildren.forEach((el) => wrapper.appendChild(el));
        this.content.appendChild(wrapper);
        this.hiddenWrapper = wrapper;
      }

      toggle() {
        this.expanded = !this.expanded;
        this.hiddenWrapper.classList.toggle('seo-text-block__hidden--expanded', this.expanded);
        this.button.classList.toggle('seo-text-block__toggle--expanded', this.expanded);
        this.button.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
        this.label.textContent = this.expanded ? this.seeLessText : this.readMoreText;
      }
    }
  );
}
